import { Address } from '@anyx/shared-utils';

export const CityDisplay = ({ address }: { address: Address; hasPrevious: boolean }) => {
  return address?.cityName ? <span>{address?.cityName}</span> : null;
};
